


// // // // import React from 'react';
// // // // import toast from 'react-hot-toast';

// // // // const Step1SchoolInfo = ({ data, setData, onNext }) => {
// // // //   const handleChange = (e) => {
// // // //     const { name, value } = e.target;
// // // //     setData({ ...data, [name]: value });
// // // //   };

// // // //   const validate = () => {
// // // //     const required = ['name', 'address', 'email', 'phone', 'description', 'type']; // ✅ Added 'phone'
// // // //     for (let field of required) {
// // // //       if (!data[field] || data[field].trim() === '') {
// // // //         toast.error(`Please fill in ${field}`);
// // // //         return false;
// // // //       }
// // // //     }
// // // //     return true;
// // // //   };

// // // //   const handleNext = () => {
// // // //     if (validate()) onNext();
// // // //   };

// // // //   return (
// // // //     <div className="space-y-6">
// // // //       {/* Section Header */}
// // // //       <div className="mb-4 text-center">
// // // //         <h3 className="text-xl font-semibold text-white">Step 1: School Information</h3>
// // // //         <p className="text-gray-400 text-sm">Tell us about your school to get started.</p>
// // // //       </div>

// // // //       {/* Form Fields */}
// // // //       <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// // // //         <div>
// // // //           <label className="block text-sm mb-1 text-gray-300">
// // // //             School Name <span className="text-red-400">*</span>
// // // //           </label>
// // // //           <input
// // // //             type="text"
// // // //             name="name"
// // // //             value={data.name}
// // // //             onChange={handleChange}
// // // //             className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
// // // //             placeholder="Enter school name"
// // // //           />
// // // //         </div>

// // // //         <div>
// // // //           <label className="block text-sm mb-1 text-gray-300">
// // // //             Address <span className="text-red-400">*</span>
// // // //           </label>
// // // //           <input
// // // //             type="text"
// // // //             name="address"
// // // //             value={data.address}
// // // //             onChange={handleChange}
// // // //             className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
// // // //             placeholder="Enter school address"
// // // //           />
// // // //         </div>

// // // //         <div>
// // // //           <label className="block text-sm mb-1 text-gray-300">
// // // //             Email <span className="text-red-400">*</span>
// // // //           </label>
// // // //           <input
// // // //             type="email"
// // // //             name="email"
// // // //             value={data.email}
// // // //             onChange={handleChange}
// // // //             className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
// // // //             placeholder="Enter email"
// // // //           />
// // // //         </div>

// // // //         <div>
// // // //           <label className="block text-sm mb-1 text-gray-300">
// // // //             Phone <span className="text-red-400">*</span>
// // // //           </label>
// // // //           <input
// // // //             type="text"
// // // //             name="phone"
// // // //             value={data.phone}
// // // //             onChange={handleChange}
// // // //             className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
// // // //             placeholder="Enter phone number"
// // // //           />
// // // //         </div>
// // // //       </div>

// // // //       {/* Description */}
// // // //       <div>
// // // //         <label className="block text-sm mb-1 text-gray-300">
// // // //           Description <span className="text-red-400">*</span>
// // // //         </label>
// // // //         <textarea
// // // //           name="description"
// // // //           rows={3}
// // // //           value={data.description}
// // // //           onChange={handleChange}
// // // //           className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-white placeholder-gray-400"
// // // //           placeholder="Write a short description of your school..."
// // // //         ></textarea>
// // // //       </div>

// // // //       {/* Type */}
// // // //       <div>
// // // //         <label className="block text-sm mb-1 text-gray-300">
// // // //           School Type <span className="text-red-400">*</span>
// // // //         </label>
// // // //         <select
// // // //           name="type"
// // // //           value={data.type}
// // // //           onChange={handleChange}
// // // //           className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
// // // //         >
// // // //           <option value="">-- Select Type --</option>
// // // //           <option value="private">Private</option>
// // // //           <option value="public">Public</option>
// // // //         </select>
// // // //       </div>

// // // //       {/* Subscription Type */}
// // // //       <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
// // // //         <label className="text-gray-300 font-medium">Subscription:</label>
// // // //         <div className="flex gap-6 text-sm">
// // // //           <label className="flex items-center gap-2 text-gray-300">
// // // //             <input
// // // //               type="radio"
// // // //               name="subscription"
// // // //               value="free"
// // // //               checked={data.subscription === 'free'}
// // // //               onChange={handleChange}
// // // //               className="accent-indigo-500"
// // // //             />
// // // //             Free Trial
// // // //           </label>
// // // //           <label className="flex items-center gap-2 text-gray-300">
// // // //             <input
// // // //               type="radio"
// // // //               name="subscription"
// // // //               value="paid"
// // // //               checked={data.subscription === 'paid'}
// // // //               onChange={handleChange}
// // // //               className="accent-indigo-500"
// // // //             />
// // // //             Paid Plan
// // // //           </label>
// // // //         </div>
// // // //       </div>

// // // //       {/* Navigation Button */}
// // // //       <div className="pt-6 flex justify-end">
// // // //         <button
// // // //           onClick={handleNext}
// // // //           className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-md"
// // // //         >
// // // //           Next Step →
// // // //         </button>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Step1SchoolInfo;






// // // import React, { useEffect, useState } from 'react';
// // // import toast from 'react-hot-toast';
// // // import { InformationCircleIcon } from '@heroicons/react/24/outline';

// // // const indianStates = [
// // //     { name: 'Select State', code: '' },
// // //     { name: 'Uttar Pradesh', code: 'UP' },
// // //     { name: 'Maharashtra', code: 'MH' },
// // //     { name: 'Karnataka', code: 'KA' },
// // //     { name: 'Tamil Nadu', code: 'TN' },
// // //     { name: 'Delhi', code: 'DL' },
// // //     { name: 'Rajasthan', code: 'RJ' },
// // //     // ... add all states
// // // ];

// // // // Example mapping: state code → array of cities
// // // const stateCityMap = {
// // //     UP: ['Mirzapur', 'Bhadohi', 'Lucknow', 'Kanpur', 'Varanasi', 'Prayagraj', 'Sonbhadra', 'Sultanpur'],
// // //     MH: ['Mumbai', 'Pune', 'Nagpur'],
// // //     KA: ['Bengaluru', 'Mysore', 'Mangalore'],
// // //     TN: ['Chennai', 'Coimbatore', 'Madurai'],
// // //     DL: ['New Delhi'],
// // //     RJ: ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer'],
// // //     // ... etc
// // // };

// // // const Step1SchoolInfo = ({ data, setData, onNext }) => {
// // //     const [customSchoolId, setCustomSchoolId] = useState(false);
// // //     const [cityOptions, setCityOptions] = useState([]);
// // //     const [customBoard, setCustomBoard] = useState(false);
// // //     const [customMedium, setCustomMedium] = useState(false);


// // //     // When state changes, update city options
// // //     useEffect(() => {
// // //         if (data.state && stateCityMap[data.state]) {
// // //             setCityOptions(stateCityMap[data.state]);
// // //         } else {
// // //             setCityOptions([]);
// // //         }
// // //     }, [data.state]);

// // //     const handleChange = (e) => {
// // //         const { name, value } = e.target;
// // //         setData({ ...data, [name]: value });
// // //     };

// // //     const handleToggleSchoolId = () => {
// // //         setCustomSchoolId(!customSchoolId);
// // //         if (!customSchoolId) {
// // //             // Clearing if toggling off manual
// // //             setData({ ...data, schoolId: '' });
// // //         }
// // //     };

// // //     const validate = () => {
// // //         // Required fields
// // //         const required = [
// // //             'name',
// // //             'description',
// // //             'establishedYear',
// // //             'boardAffiliation',
// // //             'medium',
// // //             'country',
// // //             'state',
// // //             'city',
// // //             'fullAddress',
// // //             'pincode',
// // //             'email',
// // //             'contactEmail',
// // //             'phone',
// // //             'subscriptionType',
// // //         ];
// // //         for (let field of required) {
// // //             if (!data[field] || data[field].trim() === '') {
// // //                 toast.error(`Please fill in ${field}`);
// // //                 return false;
// // //             }
// // //         }

// // //         // If custom ID, require schoolId
// // //         if (customSchoolId) {
// // //             if (!data.schoolId || data.schoolId.trim() === '') {
// // //                 toast.error('Please enter a School ID or uncheck manual entry');
// // //                 return false;
// // //             }
// // //         }

// // //         // Validate pincode: numeric, 6 digits
// // //         if (!/^\d{6}$/.test(data.pincode)) {
// // //             toast.error('Pincode must be a 6‑digit number');
// // //             return false;
// // //         }

// // //         // Validate establishment year: 4 digits and not in future
// // //         const yr = parseInt(data.establishedYear, 10);
// // //         const currentYear = new Date().getFullYear();
// // //         if (isNaN(yr) || yr < 1800 || yr > currentYear) {
// // //             toast.error(`Year of Establishment must be a valid year ≤ ${currentYear}`);
// // //             return false;
// // //         }

// // //         return true;
// // //     };

// // //     const handleNext = () => {
// // //         if (validate()) {
// // //             onNext();
// // //         }
// // //     };

// // //     return (
// // //         <div className="space-y-6">
// // //             {/* Header */}
// // //             <div className="mb-4 text-center">
// // //                 <h3 className="text-xl font-semibold text-white">Step 1: School Information</h3>
// // //                 <p className="text-gray-400 text-sm">
// // //                     Provide accurate, complete details. Fields marked with <span className="text-red-400">*</span> are mandatory.
// // //                 </p>
// // //             </div>

// // //             {/* Basic School Details */}
// // //             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         School Name <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <input
// // //                         type="text"
// // //                         name="name"
// // //                         value={data.name || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="Enter school name"
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Description <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <textarea
// // //                         name="description"
// // //                         rows={2}
// // //                         value={data.description || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="Short description of your school"
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Year of Establishment <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <select
// // //                         name="establishedYear"
// // //                         value={data.establishedYear || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md text-white"
// // //                     >
// // //                         <option value="">-- Select Year --</option>
// // //                         {Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => 1900 + i)
// // //                             .reverse()
// // //                             .map((year) => (
// // //                                 <option key={year} value={year}>
// // //                                     {year}
// // //                                 </option>
// // //                             ))}
// // //                     </select>
// // //                 </div>

// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Board Affiliation <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <select
// // //                         name="boardAffiliation"
// // //                         value={data.boardAffiliation || ''}
// // //                         onChange={(e) => {
// // //                             if (e.target.value === 'Other') {
// // //                                 setCustomBoard(true);
// // //                                 setData({ ...data, boardAffiliation: '' });
// // //                             } else {
// // //                                 setCustomBoard(false);
// // //                                 handleChange(e);
// // //                             }
// // //                         }}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md text-white"
// // //                     >
// // //                         <option value="">-- Select Board --</option>
// // //                         <option value="CBSE">CBSE</option>
// // //                         <option value="ICSE">ICSE</option>
// // //                         <option value="State Board">State Board</option>
// // //                         <option value="IB">IB</option>
// // //                         <option value="IGCSE">IGCSE</option>
// // //                         <option value="Other">Other</option>
// // //                     </select>
// // //                     {customBoard && (
// // //                         <input
// // //                             type="text"
// // //                             name="boardAffiliation"
// // //                             value={data.boardAffiliation || ''}
// // //                             onChange={handleChange}
// // //                             className="mt-2 w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md text-white placeholder-gray-400"
// // //                             placeholder="Enter board name"
// // //                         />
// // //                     )}
// // //                 </div>

// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300 flex items-center">
// // //                         Medium of Instruction <span className="text-red-400">*</span>
// // //                         <InformationCircleIcon className="w-4 h-4 ml-1 text-gray-400" title="Primary teaching medium" />
// // //                     </label>
// // //                     <select
// // //                         name="medium"
// // //                         value={data.medium || ''}
// // //                         onChange={(e) => {
// // //                             if (e.target.value === 'Other') {
// // //                                 setCustomMedium(true);
// // //                                 setData({ ...data, medium: '' });
// // //                             } else {
// // //                                 setCustomMedium(false);
// // //                                 handleChange(e);
// // //                             }
// // //                         }}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md text-white"
// // //                     >
// // //                         <option value="">-- Select Medium --</option>
// // //                         <option value="English">English</option>
// // //                         <option value="Hindi">Hindi</option>
// // //                         <option value="Bilingual">Bilingual</option>
// // //                         <option value="Other">Other</option>
// // //                     </select>
// // //                     {customMedium && (
// // //                         <input
// // //                             type="text"
// // //                             name="medium"
// // //                             value={data.medium || ''}
// // //                             onChange={handleChange}
// // //                             className="mt-2 w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md text-white placeholder-gray-400"
// // //                             placeholder="Enter medium"
// // //                         />
// // //                     )}
// // //                 </div>

// // //             </div>




// // //             {/* Address Section */}
// // //             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Country <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <input
// // //                         type="text"
// // //                         name="country"
// // //                         value={data.country || 'India'}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="India"
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         State <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <select
// // //                         name="state"
// // //                         value={data.state || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white"
// // //                     >
// // //                         {indianStates.map((st) => (
// // //                             <option key={st.code} value={st.code}>
// // //                                 {st.name}
// // //                             </option>
// // //                         ))}
// // //                     </select>
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         City / District <span className="text-red-400">*</span>
// // //                     </label>
// // //                     {cityOptions.length > 0 ? (
// // //                         <select
// // //                             name="city"
// // //                             value={data.city || ''}
// // //                             onChange={handleChange}
// // //                             className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white"
// // //                         >
// // //                             <option value="">-- Select City --</option>
// // //                             {cityOptions.map((c) => (
// // //                                 <option key={c} value={c}>
// // //                                     {c}
// // //                                 </option>
// // //                             ))}
// // //                         </select>
// // //                     ) : (
// // //                         <input
// // //                             type="text"
// // //                             name="city"
// // //                             value={data.city || ''}
// // //                             onChange={handleChange}
// // //                             className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                             placeholder="Enter city/district"
// // //                         />
// // //                     )}
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Full Address <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <input
// // //                         type="text"
// // //                         name="fullAddress"
// // //                         value={data.fullAddress || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="Street, area, locality"
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text.gray-300">
// // //                         Pincode <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <input
// // //                         type="text"
// // //                         name="pincode"
// // //                         value={data.pincode || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="6-digit pincode"
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Landmark (optional)
// // //                     </label>
// // //                     <input
// // //                         type="text"
// // //                         name="landmark"
// // //                         value={data.landmark || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="Near a landmark"
// // //                     />
// // //                 </div>
// // //             </div>

// // //             {/* Contact Information */}
// // //             <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Official Email <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <input
// // //                         type="email"
// // //                         name="email"
// // //                         value={data.email || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="school@example.com"
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Contact Us Email <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <input
// // //                         type="email"
// // //                         name="contactEmail"
// // //                         value={data.contactEmail || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="contact@example.com"
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label className="block text-sm mb-1 text-gray-300">
// // //                         Phone Number <span className="text-red-400">*</span>
// // //                     </label>
// // //                     <input
// // //                         type="text"
// // //                         name="phone"
// // //                         value={data.phone || ''}
// // //                         onChange={handleChange}
// // //                         className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white placeholder-gray-400"
// // //                         placeholder="10-digit phone number"
// // //                     />
// // //                 </div>
// // //             </div>

// // //             {/* Subscription Type */}
// // //             <div>
// // //                 <label className="block text-sm mb-1 text-gray-300">
// // //                     Subscription Type <span className="text-red-400">*</span>
// // //                 </label>
// // //                 <select
// // //                     name="subscriptionType"
// // //                     value={data.subscriptionType || ''}
// // //                     onChange={handleChange}
// // //                     className="w-full px-4 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-indigo-500 focus:outline-none text-white"
// // //                 >
// // //                     <option value="">-- Select Subscription --</option>
// // //                     <option value="free">Free</option>
// // //                     <option value="paid">Paid</option>
// // //                 </select>
// // //             </div>


// // //             {/* Navigation Button */}
// // //             <div className="pt-6 flex justify-end">
// // //                 <button
// // //                     onClick={handleNext}
// // //                     className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // //                 >
// // //                     Next Step →
// // //                 </button>
// // //             </div>
// // //         </div>
// // //     );
// // // };

// // // export default Step1SchoolInfo;


// // import React, { useEffect, useState } from 'react';
// // import toast from 'react-hot-toast';
// // import { InformationCircleIcon } from '@heroicons/react/24/outline';
// // import { indianStates, stateCityMap } from '../assets/IndianStateCities';

// // const inputClass =
// //   'w-full px-4 py-2.5 bg-[#F4F8FC] border border-[#D8E4F5] rounded-lg text-[#101826] placeholder-[#8891A0] font-[\'Sora\',sans-serif] text-sm focus:outline-none focus:ring-2 focus:ring-[#2E63B8]/40 focus:border-[#2E63B8]';
// // const labelClass = 'block text-sm mb-1.5 text-[#5A6478] font-[\'Sora\',sans-serif]';

// // const Step1SchoolInfo = ({ data, setData, onNext }) => {
// //     const [customSchoolId, setCustomSchoolId] = useState(false);
// //     const [cityOptions, setCityOptions] = useState([]);
// //     const [customBoard, setCustomBoard] = useState(false);
// //     const [customMedium, setCustomMedium] = useState(false);

// //     // When state changes, update city options
// //     useEffect(() => {
// //         if (data.state && stateCityMap[data.state]) {
// //             setCityOptions(stateCityMap[data.state]);
// //         } else {
// //             setCityOptions([]);
// //         }
// //     }, [data.state]);

// //     const handleChange = (e) => {
// //         const { name, value } = e.target;
// //         setData({ ...data, [name]: value });
// //     };

// //     const validate = () => {
// //         const required = [
// //             'name', 'description', 'establishedYear', 'boardAffiliation',
// //             'medium', 'country', 'state', 'city', 'fullAddress',
// //             'pincode', 'email', 'contactEmail', 'phone', 'subscriptionType',
// //         ];
// //         for (let field of required) {
// //             if (!data[field] || data[field].trim() === '') {
// //                 toast.error(`Please fill in ${field}`);
// //                 return false;
// //             }
// //         }

// //         if (customSchoolId) {
// //             if (!data.schoolId || data.schoolId.trim() === '') {
// //                 toast.error('Please enter a School ID or uncheck manual entry');
// //                 return false;
// //             }
// //         }

// //         if (!/^\d{6}$/.test(data.pincode)) {
// //             toast.error('Pincode must be a 6‑digit number');
// //             return false;
// //         }

// //         const yr = parseInt(data.establishedYear, 10);
// //         const currentYear = new Date().getFullYear();
// //         if (isNaN(yr) || yr < 1800 || yr > currentYear) {
// //             toast.error(`Year of Establishment must be a valid year ≤ ${currentYear}`);
// //             return false;
// //         }

// //         return true;
// //     };

// //     const handleNext = () => {
// //         if (validate()) {
// //             onNext();
// //         }
// //     };

// //     return (
// //         <div className="space-y-6">
// //             {/* Header */}
// //             <div className="mb-4 text-center">
// //                 <h3 className="font-['Sora',sans-serif] text-xl font-semibold text-[#101826]">Step 1: School Information</h3>
// //                 <p className="text-[#5A6478] font-['Sora',sans-serif] text-sm">
// //                     Provide accurate, complete details. Fields marked with <span className="text-red-500">*</span> are mandatory.
// //                 </p>
// //             </div>

// //             {/* Basic School Details */}
// //             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// //                 <div>
// //                     <label className={labelClass}>
// //                         School Name <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="text"
// //                         name="name"
// //                         value={data.name || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="Enter school name"
// //                     />
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         Description <span className="text-red-500">*</span>
// //                     </label>
// //                     <textarea
// //                         name="description"
// //                         rows={2}
// //                         value={data.description || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="Short description of your school"
// //                     />
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         Year of Establishment <span className="text-red-500">*</span>
// //                     </label>
// //                     <select
// //                         name="establishedYear"
// //                         value={data.establishedYear || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                     >
// //                         <option value="">-- Select Year --</option>
// //                         {Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => 1900 + i)
// //                             .reverse()
// //                             .map((year) => (
// //                                 <option key={year} value={year}>
// //                                     {year}
// //                                 </option>
// //                             ))}
// //                     </select>
// //                 </div>

// //                 <div>
// //                     <label className={labelClass}>
// //                         Board Affiliation <span className="text-red-500">*</span>
// //                     </label>
// //                     <select
// //                         name="boardAffiliation"
// //                         value={data.boardAffiliation || ''}
// //                         onChange={(e) => {
// //                             if (e.target.value === 'Other') {
// //                                 setCustomBoard(true);
// //                                 setData({ ...data, boardAffiliation: '' });
// //                             } else {
// //                                 setCustomBoard(false);
// //                                 handleChange(e);
// //                             }
// //                         }}
// //                         className={inputClass}
// //                     >
// //                         <option value="">-- Select Board --</option>
// //                         <option value="CBSE">CBSE</option>
// //                         <option value="ICSE">ICSE</option>
// //                         <option value="State Board">State Board</option>
// //                         <option value="IB">IB</option>
// //                         <option value="IGCSE">IGCSE</option>
// //                         <option value="Other">Other</option>
// //                     </select>
// //                     {customBoard && (
// //                         <input
// //                             type="text"
// //                             name="boardAffiliation"
// //                             value={data.boardAffiliation || ''}
// //                             onChange={handleChange}
// //                             className={`mt-2 ${inputClass}`}
// //                             placeholder="Enter board name"
// //                         />
// //                     )}
// //                 </div>

// //                 <div>
// //                     <label className={`${labelClass} flex items-center gap-1`}>
// //                         Medium of Instruction <span className="text-red-500">*</span>
// //                         <InformationCircleIcon className="w-4 h-4 text-[#8891A0]" title="Primary teaching medium" />
// //                     </label>
// //                     <select
// //                         name="medium"
// //                         value={data.medium || ''}
// //                         onChange={(e) => {
// //                             if (e.target.value === 'Other') {
// //                                 setCustomMedium(true);
// //                                 setData({ ...data, medium: '' });
// //                             } else {
// //                                 setCustomMedium(false);
// //                                 handleChange(e);
// //                             }
// //                         }}
// //                         className={inputClass}
// //                     >
// //                         <option value="">-- Select Medium --</option>
// //                         <option value="English">English</option>
// //                         <option value="Hindi">Hindi</option>
// //                         <option value="Bilingual">Bilingual</option>
// //                         <option value="Other">Other</option>
// //                     </select>
// //                     {customMedium && (
// //                         <input
// //                             type="text"
// //                             name="medium"
// //                             value={data.medium || ''}
// //                             onChange={handleChange}
// //                             className={`mt-2 ${inputClass}`}
// //                             placeholder="Enter medium"
// //                         />
// //                     )}
// //                 </div>
// //             </div>

// //             {/* Address Section */}
// //             <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
// //                 <div>
// //                     <label className={labelClass}>
// //                         Country <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="text"
// //                         name="country"
// //                         value={data.country || 'India'}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="India"
// //                     />
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         State <span className="text-red-500">*</span>
// //                     </label>
// //                     <select
// //                         name="state"
// //                         value={data.state || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                     >
// //                         {indianStates.map((st) => (
// //                             <option key={st.code} value={st.code}>
// //                                 {st.name}
// //                             </option>
// //                         ))}
// //                     </select>
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         City / District <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="text"
// //                         name="city"
// //                         list="city-options"
// //                         value={data.city || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder={cityOptions.length > 0 ? 'Select or type your city/district' : 'Enter city/district'}
// //                     />
// //                     {cityOptions.length > 0 && (
// //                         <datalist id="city-options">
// //                             {cityOptions.map((c) => (
// //                                 <option key={c} value={c} />
// //                             ))}
// //                         </datalist>
// //                     )}
// //                     {cityOptions.length > 0 && (
// //                         <p className="text-xs text-[#8891A0] font-['Sora',sans-serif] mt-1">
// //                             Showing suggestions for major cities — you can also type any city/district.
// //                         </p>
// //                     )}
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         Full Address <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="text"
// //                         name="fullAddress"
// //                         value={data.fullAddress || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="Street, area, locality"
// //                     />
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         Pincode <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="text"
// //                         name="pincode"
// //                         value={data.pincode || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="6-digit pincode"
// //                     />
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>Landmark (optional)</label>
// //                     <input
// //                         type="text"
// //                         name="landmark"
// //                         value={data.landmark || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="Near a landmark"
// //                     />
// //                 </div>
// //             </div>

// //             {/* Contact Information */}
// //             <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
// //                 <div>
// //                     <label className={labelClass}>
// //                         Official Email <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="email"
// //                         name="email"
// //                         value={data.email || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="school@example.com"
// //                     />
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         Contact Us Email <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="email"
// //                         name="contactEmail"
// //                         value={data.contactEmail || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="contact@example.com"
// //                     />
// //                 </div>
// //                 <div>
// //                     <label className={labelClass}>
// //                         Phone Number <span className="text-red-500">*</span>
// //                     </label>
// //                     <input
// //                         type="text"
// //                         name="phone"
// //                         value={data.phone || ''}
// //                         onChange={handleChange}
// //                         className={inputClass}
// //                         placeholder="10-digit phone number"
// //                     />
// //                 </div>
// //             </div>

// //             {/* Subscription Type */}
// //             <div>
// //                 <label className={labelClass}>
// //                     Subscription Type <span className="text-red-500">*</span>
// //                 </label>
// //                 <select
// //                     name="subscriptionType"
// //                     value={data.subscriptionType || ''}
// //                     onChange={handleChange}
// //                     className={inputClass}
// //                 >
// //                     <option value="">-- Select Subscription --</option>
// //                     <option value="free">Free</option>
// //                     <option value="paid">Paid</option>
// //                 </select>
// //             </div>

// //             {/* Navigation Button */}
// //             <div className="pt-6 flex justify-end">
// //                 <button
// //                     onClick={handleNext}
// //                     className="px-6 py-2.5 bg-[#163863] hover:bg-[#2E63B8] text-white font-['Sora',sans-serif] font-semibold rounded-lg transition-colors duration-200 shadow-sm"
// //                 >
// //                     Next step →
// //                 </button>
// //             </div>
// //         </div>
// //     );
// // };

// // export default Step1SchoolInfo;


// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import { InformationCircleIcon } from '@heroicons/react/24/outline';
// import { indianStates, stateCityMap } from '../assets/IndianStateCities';

// const displayFont = { fontFamily: "'Fraunces', serif" };

// const inputClass =
//   'w-full px-4 py-2.5 bg-white border border-[#E3E8F0] rounded-xl text-[#101826] placeholder-[#A6AFBD] text-sm shadow-[0_1px_2px_rgba(16,24,38,0.04)] transition-all duration-150 focus:outline-none focus:ring-4 focus:ring-[#2E63B8]/10 focus:border-[#2E63B8]';
// const labelClass = 'block text-[13px] mb-1.5 text-[#5A6478] font-medium';

// const SectionHeading = ({ children }) => (
//   <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
//     {children}
//   </h4>
// );

// const Step1SchoolInfo = ({ data, setData, onNext }) => {
//     const [customSchoolId, setCustomSchoolId] = useState(false);
//     const [cityOptions, setCityOptions] = useState([]);
//     const [customBoard, setCustomBoard] = useState(false);
//     const [customMedium, setCustomMedium] = useState(false);

//     useEffect(() => {
//         if (data.state && stateCityMap[data.state]) {
//             setCityOptions(stateCityMap[data.state]);
//         } else {
//             setCityOptions([]);
//         }
//     }, [data.state]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setData({ ...data, [name]: value });
//     };

//     const validate = () => {
//         const required = [
//             'name', 'description', 'establishedYear', 'boardAffiliation',
//             'medium', 'country', 'state', 'city', 'fullAddress',
//             'pincode', 'email', 'contactEmail', 'phone', 'subscriptionType',
//         ];
//         for (let field of required) {
//             if (!data[field] || data[field].trim() === '') {
//                 toast.error(`Please fill in ${field}`);
//                 return false;
//             }
//         }

//         if (customSchoolId) {
//             if (!data.schoolId || data.schoolId.trim() === '') {
//                 toast.error('Please enter a School ID or uncheck manual entry');
//                 return false;
//             }
//         }

//         if (!/^\d{6}$/.test(data.pincode)) {
//             toast.error('Pincode must be a 6‑digit number');
//             return false;
//         }

//         const yr = parseInt(data.establishedYear, 10);
//         const currentYear = new Date().getFullYear();
//         if (isNaN(yr) || yr < 1800 || yr > currentYear) {
//             toast.error(`Year of Establishment must be a valid year ≤ ${currentYear}`);
//             return false;
//         }

//         return true;
//     };

//     const handleNext = () => {
//         if (validate()) {
//             onNext();
//         }
//     };

//     return (
//         <div className="space-y-10">
//             <div className="text-center -mt-2 mb-2">
//                 <h3 style={displayFont} className="text-xl text-[#101826]">Step 1: School Information</h3>
//                 <p className="text-[#5A6478] text-sm mt-1">
//                     Provide accurate, complete details. Fields marked with <span className="text-red-500">*</span> are mandatory.
//                 </p>
//             </div>

//             {/* Basic details */}
//             <div>
//                 <SectionHeading>Basic details</SectionHeading>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                     <div>
//                         <label className={labelClass}>
//                             School Name <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="text"
//                             name="name"
//                             value={data.name || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="Enter school name"
//                         />
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             Description <span className="text-red-500">*</span>
//                         </label>
//                         <textarea
//                             name="description"
//                             rows={2}
//                             value={data.description || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="Short description of your school"
//                         />
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             Year of Establishment <span className="text-red-500">*</span>
//                         </label>
//                         <select
//                             name="establishedYear"
//                             value={data.establishedYear || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                         >
//                             <option value="">-- Select Year --</option>
//                             {Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => 1900 + i)
//                                 .reverse()
//                                 .map((year) => (
//                                     <option key={year} value={year}>
//                                         {year}
//                                     </option>
//                                 ))}
//                         </select>
//                     </div>

//                     <div>
//                         <label className={labelClass}>
//                             Board Affiliation <span className="text-red-500">*</span>
//                         </label>
//                         <select
//                             name="boardAffiliation"
//                             value={data.boardAffiliation || ''}
//                             onChange={(e) => {
//                                 if (e.target.value === 'Other') {
//                                     setCustomBoard(true);
//                                     setData({ ...data, boardAffiliation: '' });
//                                 } else {
//                                     setCustomBoard(false);
//                                     handleChange(e);
//                                 }
//                             }}
//                             className={inputClass}
//                         >
//                             <option value="">-- Select Board --</option>
//                             <option value="CBSE">CBSE</option>
//                             <option value="ICSE">ICSE</option>
//                             <option value="State Board">State Board</option>
//                             <option value="IB">IB</option>
//                             <option value="IGCSE">IGCSE</option>
//                             <option value="Other">Other</option>
//                         </select>
//                         {customBoard && (
//                             <input
//                                 type="text"
//                                 name="boardAffiliation"
//                                 value={data.boardAffiliation || ''}
//                                 onChange={handleChange}
//                                 className={`mt-2 ${inputClass}`}
//                                 placeholder="Enter board name"
//                             />
//                         )}
//                     </div>

//                     <div>
//                         <label className={`${labelClass} flex items-center gap-1`}>
//                             Medium of Instruction <span className="text-red-500">*</span>
//                             <InformationCircleIcon className="w-4 h-4 text-[#A6AFBD]" title="Primary teaching medium" />
//                         </label>
//                         <select
//                             name="medium"
//                             value={data.medium || ''}
//                             onChange={(e) => {
//                                 if (e.target.value === 'Other') {
//                                     setCustomMedium(true);
//                                     setData({ ...data, medium: '' });
//                                 } else {
//                                     setCustomMedium(false);
//                                     handleChange(e);
//                                 }
//                             }}
//                             className={inputClass}
//                         >
//                             <option value="">-- Select Medium --</option>
//                             <option value="English">English</option>
//                             <option value="Hindi">Hindi</option>
//                             <option value="Bilingual">Bilingual</option>
//                             <option value="Other">Other</option>
//                         </select>
//                         {customMedium && (
//                             <input
//                                 type="text"
//                                 name="medium"
//                                 value={data.medium || ''}
//                                 onChange={handleChange}
//                                 className={`mt-2 ${inputClass}`}
//                                 placeholder="Enter medium"
//                             />
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Location */}
//             <div>
//                 <SectionHeading>Location</SectionHeading>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                     <div>
//                         <label className={labelClass}>
//                             Country <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="text"
//                             name="country"
//                             value={data.country || 'India'}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="India"
//                         />
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             State <span className="text-red-500">*</span>
//                         </label>
//                         <select
//                             name="state"
//                             value={data.state || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                         >
//                             {indianStates.map((st) => (
//                                 <option key={st.code} value={st.code}>
//                                     {st.name}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             City / District <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="text"
//                             name="city"
//                             list="city-options"
//                             value={data.city || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder={cityOptions.length > 0 ? 'Select or type your city/district' : 'Enter city/district'}
//                         />
//                         {cityOptions.length > 0 && (
//                             <datalist id="city-options">
//                                 {cityOptions.map((c) => (
//                                     <option key={c} value={c} />
//                                 ))}
//                             </datalist>
//                         )}
//                         {cityOptions.length > 0 && (
//                             <p className="text-xs text-[#A6AFBD] mt-1.5">
//                                 Showing suggestions for major cities — you can also type any city/district.
//                             </p>
//                         )}
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             Full Address <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="text"
//                             name="fullAddress"
//                             value={data.fullAddress || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="Street, area, locality"
//                         />
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             Pincode <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="text"
//                             name="pincode"
//                             value={data.pincode || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="6-digit pincode"
//                         />
//                     </div>
//                     <div>
//                         <label className={labelClass}>Landmark (optional)</label>
//                         <input
//                             type="text"
//                             name="landmark"
//                             value={data.landmark || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="Near a landmark"
//                         />
//                     </div>
//                 </div>
//             </div>

//             {/* Contact & plan */}
//             <div>
//                 <SectionHeading>Contact &amp; plan</SectionHeading>
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
//                     <div>
//                         <label className={labelClass}>
//                             Official Email <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="email"
//                             name="email"
//                             value={data.email || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="school@example.com"
//                         />
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             Contact Us Email <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="email"
//                             name="contactEmail"
//                             value={data.contactEmail || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="contact@example.com"
//                         />
//                     </div>
//                     <div>
//                         <label className={labelClass}>
//                             Phone Number <span className="text-red-500">*</span>
//                         </label>
//                         <input
//                             type="text"
//                             name="phone"
//                             value={data.phone || ''}
//                             onChange={handleChange}
//                             className={inputClass}
//                             placeholder="10-digit phone number"
//                         />
//                     </div>
//                 </div>

//                 <div className="max-w-sm">
//                     <label className={labelClass}>
//                         Subscription Type <span className="text-red-500">*</span>
//                     </label>
//                     <select
//                         name="subscriptionType"
//                         value={data.subscriptionType || ''}
//                         onChange={handleChange}
//                         className={inputClass}
//                     >
//                         <option value="">-- Select Subscription --</option>
//                         <option value="free">Free</option>
//                         <option value="paid">Paid</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Navigation Button */}
//             <div className="pt-2 flex justify-end">
//                 <button
//                     onClick={handleNext}
//                     className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gradient-to-r from-[#163863] to-[#2E63B8] text-white font-semibold shadow-lg shadow-[#163863]/25 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
//                 >
//                     Next step →
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default Step1SchoolInfo;


import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { InformationCircleIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { indianStates, stateCityMap } from '../assets/IndianStateCities';

const displayFont = { fontFamily: "'Fraunces', serif" };

// outline-none + a custom focus shadow (instead of the browser's native
// black/blue focus ring) applied via box-shadow only, transitioning smoothly
// instead of snapping in.
const fieldClass =
  'w-full px-4 py-2.5 bg-white border border-[#E3E8F0] rounded-xl text-[#101826] placeholder-[#A6AFBD] text-sm shadow-[0_1px_2px_rgba(16,24,38,0.04)] outline-none transition-[box-shadow,border-color] duration-200 ease-out focus:border-[#2E63B8] focus:shadow-[0_0_0_4px_rgba(46,99,184,0.15)]';
// appearance-none removes the native select chrome (which is what usually
// carries the stray black focus ring); pr-9 leaves room for our own chevron.
const selectClass = `${fieldClass} appearance-none pr-9 cursor-pointer`;
const labelClass = 'block text-[13px] mb-1.5 text-[#5A6478] font-medium';
const fieldStyle = { outline: 'none' };

const SectionHeading = ({ children }) => (
  <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
    {children}
  </h4>
);

const Select = ({ children, ...props }) => (
  <div className="relative">
    <select {...props} className={selectClass} style={fieldStyle}>
      {children}
    </select>
    <ChevronDownIcon className="w-4 h-4 text-[#8891A0] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
  </div>
);

const Step1SchoolInfo = ({ data, setData, onNext }) => {
    const [customSchoolId, setCustomSchoolId] = useState(false);
    const [cityOptions, setCityOptions] = useState([]);
    const [customBoard, setCustomBoard] = useState(false);
    const [customMedium, setCustomMedium] = useState(false);

    useEffect(() => {
        if (data.state && stateCityMap[data.state]) {
            setCityOptions(stateCityMap[data.state]);
        } else {
            setCityOptions([]);
        }
    }, [data.state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const validate = () => {
        const required = [
            'name', 'description', 'establishedYear', 'boardAffiliation',
            'medium', 'country', 'state', 'city', 'fullAddress',
            'pincode', 'email', 'contactEmail', 'phone', 'subscriptionType',
        ];
        for (let field of required) {
            if (!data[field] || data[field].trim() === '') {
                toast.error(`Please fill in ${field}`);
                return false;
            }
        }

        if (customSchoolId) {
            if (!data.schoolId || data.schoolId.trim() === '') {
                toast.error('Please enter a School ID or uncheck manual entry');
                return false;
            }
        }

        if (!/^\d{6}$/.test(data.pincode)) {
            toast.error('Pincode must be a 6‑digit number');
            return false;
        }

        const yr = parseInt(data.establishedYear, 10);
        const currentYear = new Date().getFullYear();
        if (isNaN(yr) || yr < 1800 || yr > currentYear) {
            toast.error(`Year of Establishment must be a valid year ≤ ${currentYear}`);
            return false;
        }

        return true;
    };

    const handleNext = () => {
        if (validate()) {
            onNext();
        }
    };

    return (
        <div className="space-y-10">
            <div className="text-center -mt-2 mb-2">
                <h3 style={displayFont} className="text-xl text-[#101826]">Step 1: School Information</h3>
                <p className="text-[#5A6478] text-sm mt-1">
                    Provide accurate, complete details. Fields marked with <span className="text-red-500">*</span> are mandatory.
                </p>
            </div>

            {/* Basic details */}
            <div>
                <SectionHeading>Basic details</SectionHeading>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                        <label className={labelClass}>
                            School Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={data.name || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="Enter school name"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>
                            Description <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            name="description"
                            rows={2}
                            value={data.description || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="Short description of your school"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>
                            Year of Establishment <span className="text-red-500">*</span>
                        </label>
                        <Select name="establishedYear" value={data.establishedYear || ''} onChange={handleChange}>
                            <option value="">-- Select Year --</option>
                            {Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => 1900 + i)
                                .reverse()
                                .map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                        </Select>
                    </div>

                    <div>
                        <label className={labelClass}>
                            Board Affiliation <span className="text-red-500">*</span>
                        </label>
                        <Select
                            name="boardAffiliation"
                            value={data.boardAffiliation || ''}
                            onChange={(e) => {
                                if (e.target.value === 'Other') {
                                    setCustomBoard(true);
                                    setData({ ...data, boardAffiliation: '' });
                                } else {
                                    setCustomBoard(false);
                                    handleChange(e);
                                }
                            }}
                        >
                            <option value="">-- Select Board --</option>
                            <option value="CBSE">CBSE</option>
                            <option value="ICSE">ICSE</option>
                            <option value="State Board">State Board</option>
                            <option value="IB">IB</option>
                            <option value="IGCSE">IGCSE</option>
                            <option value="Other">Other</option>
                        </Select>
                        {customBoard && (
                            <input
                                type="text"
                                name="boardAffiliation"
                                value={data.boardAffiliation || ''}
                                onChange={handleChange}
                                className={`mt-2 ${fieldClass}`}
                                style={fieldStyle}
                                placeholder="Enter board name"
                            />
                        )}
                    </div>

                    <div>
                        <label className={`${labelClass} flex items-center gap-1`}>
                            Medium of Instruction <span className="text-red-500">*</span>
                            <InformationCircleIcon className="w-4 h-4 text-[#A6AFBD]" title="Primary teaching medium" />
                        </label>
                        <Select
                            name="medium"
                            value={data.medium || ''}
                            onChange={(e) => {
                                if (e.target.value === 'Other') {
                                    setCustomMedium(true);
                                    setData({ ...data, medium: '' });
                                } else {
                                    setCustomMedium(false);
                                    handleChange(e);
                                }
                            }}
                        >
                            <option value="">-- Select Medium --</option>
                            <option value="English">English</option>
                            <option value="Hindi">Hindi</option>
                            <option value="Bilingual">Bilingual</option>
                            <option value="Other">Other</option>
                        </Select>
                        {customMedium && (
                            <input
                                type="text"
                                name="medium"
                                value={data.medium || ''}
                                onChange={handleChange}
                                className={`mt-2 ${fieldClass}`}
                                style={fieldStyle}
                                placeholder="Enter medium"
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* Location */}
            <div>
                <SectionHeading>Location</SectionHeading>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                        <label className={labelClass}>
                            Country <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="country"
                            value={data.country || 'India'}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="India"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>
                            State <span className="text-red-500">*</span>
                        </label>
                        <Select name="state" value={data.state || ''} onChange={handleChange}>
                            {indianStates.map((st) => (
                                <option key={st.code} value={st.code}>
                                    {st.name}
                                </option>
                            ))}
                        </Select>
                    </div>
                    <div>
                        <label className={labelClass}>
                            City / District <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="city"
                            list="city-options"
                            value={data.city || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder={cityOptions.length > 0 ? 'Select or type your city/district' : 'Enter city/district'}
                        />
                        {cityOptions.length > 0 && (
                            <datalist id="city-options">
                                {cityOptions.map((c) => (
                                    <option key={c} value={c} />
                                ))}
                            </datalist>
                        )}
                        {cityOptions.length > 0 && (
                            <p className="text-xs text-[#A6AFBD] mt-1.5">
                                Showing suggestions for major cities — you can also type any city/district.
                            </p>
                        )}
                    </div>
                    <div>
                        <label className={labelClass}>
                            Full Address <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="fullAddress"
                            value={data.fullAddress || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="Street, area, locality"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>
                            Pincode <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="pincode"
                            value={data.pincode || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="6-digit pincode"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>Landmark (optional)</label>
                        <input
                            type="text"
                            name="landmark"
                            value={data.landmark || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="Near a landmark"
                        />
                    </div>
                </div>
            </div>

            {/* Contact & plan */}
            <div>
                <SectionHeading>Contact &amp; plan</SectionHeading>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
                    <div>
                        <label className={labelClass}>
                            Official Email <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={data.email || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="school@example.com"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>
                            Contact Us Email <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="email"
                            name="contactEmail"
                            value={data.contactEmail || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="contact@example.com"
                        />
                    </div>
                    <div>
                        <label className={labelClass}>
                            Phone Number <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="phone"
                            value={data.phone || ''}
                            onChange={handleChange}
                            className={fieldClass}
                            style={fieldStyle}
                            placeholder="10-digit phone number"
                        />
                    </div>
                </div>

                <div className="max-w-sm">
                    <label className={labelClass}>
                        Subscription Type <span className="text-red-500">*</span>
                    </label>
                    <Select name="subscriptionType" value={data.subscriptionType || ''} onChange={handleChange}>
                        <option value="">-- Select Subscription --</option>
                        <option value="free">Free</option>
                        <option value="paid">Paid</option>
                    </Select>
                </div>
            </div>

            {/* Navigation Button */}
            <div className="pt-2 flex justify-end">
                <button
                    onClick={handleNext}
                    className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gradient-to-r from-[#163863] to-[#2E63B8] text-white text-[15px] font-semibold shadow-lg shadow-[#163863]/25 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
                >
                    Next step →
                </button>
            </div>
        </div>
    );
};

export default Step1SchoolInfo;
